import { AnyAction, Dispatch } from 'redux';

import { IAppStateContainer } from '@Reducers/index';

import { UsersApiService } from '@ClientApi/users';
import { IUserModel } from '@Shared/models';

export const ADD_MANAGERS = 'ADD_MANAGERS';
export const SET_MANAGERS_LOADING = 'SET_MANAGERS_LOADING';

export class AddManagers {
  readonly type = ADD_MANAGERS;
  constructor(public payload: IUserModel[]) {}
}

export class SetManagersLoading {
  readonly type = SET_MANAGERS_LOADING;
  constructor(public payload: boolean) {}
}

export const getAllManagers =
  (dispatch: Dispatch<AnyAction>, state: IAppStateContainer) =>
  async (forceReload = false) => {
    if (!forceReload) {
      const { managersLoading, managers } = state.managers;
      if (managersLoading || managers.length) {
        return;
      }
    }
    dispatch(new SetManagersLoading(true));
    const users = await UsersApiService.getAll();
    const managers: IUserModel[] = [];
    users.forEach((user) => {
      if (!user.is_active) {
        return;
      }
      if (!user.user_profile.can_manager_approve && !user.user_profile.is_admin && user.user_profile.role !== 'manager') {
        return;
      }
      managers.push(user);
    });
    dispatch(new AddManagers(managers));
    dispatch(new SetManagersLoading(false));
  };

export type ManagersAction = AddManagers | SetManagersLoading;
